import clsx from "clsx";
import { Controller } from "react-hook-form";

import { Button } from "@/shared/components";
import { HealthQuestionsListProps } from "@/shared/types";
import { YES_NO_OPTIONS } from "../../common/static";

export function HealthQuestionsList({
  control,
  questions,
  layoutClassName,
}: HealthQuestionsListProps) {
  return (
    <div className={layoutClassName ?? "space-y-2"}>
      {questions.map((item) => (
        <Controller
          key={item.key}
          control={control}
          name={item.key}
          render={({ field, fieldState }) => (
            <div
              className="rounded-lg border-theme-border-strong bg-theme-surface px-2 py-1  
          border-l-3i border-l-theme-primary"
            >
              <div className="flex items-center justify-between gap-2">
                <p className="text-xs font-medium leading-4 text-theme-text">{item.question}</p>
                <div className="flex shrink-0 items-center gap-2">
                  {YES_NO_OPTIONS?.map((option) => {
                    const checked = field.value === option.value;

                    return (
                      <Button
                        key={option?.value}
                        type="button"
                        variant={"secondary"}
                        className={clsx(
                          "h-7 min-w-12 rounded-md px-3 text-[11px] font-semibold transition",
                          checked
                            ? "border-theme-primary bg-theme-primary/5 !text-theme-primary shadow-sm ring-1 ring-theme-primary/20"
                            : "border-theme-border-strong bg-white text-theme-text hover:border-theme-primary/40 hover:bg-theme-primary/5"
                        )}
                        onClick={() => field.onChange(option?.value)}
                      >
                        {option?.label}
                      </Button>
                    );
                  })}
                </div>
              </div>

              {fieldState.error?.message ? (
                <p className="mt-0 text-xs text-theme-danger-bright">{fieldState.error.message}</p>
              ) : null}
            </div>
          )}
        />
      ))}
    </div>
  );
}
